import { createContext, useContext } from 'react';

/**
 * True when the current React tree is mounted inside ChannelDrawer's embedded
 * chat pane (InfluencerChatDrawer.tsx's separate React root + MemoryRouter),
 * as opposed to the same `UsersProfiles` page reached via its own top-level
 * `/influencer/:userId/...` route. Lets a handful of page-chrome bits (e.g.
 * the Campaigns/Stats sidebar's collapse behavior) opt out of drawer-unfriendly
 * defaults without threading a prop through every layer between ChannelDrawer
 * and them.
 */
const ChannelDrawerEmbedContext = createContext(false);

export const ChannelDrawerEmbedProvider = ChannelDrawerEmbedContext.Provider;

export function useIsChannelDrawerEmbed(): boolean {
  return useContext(ChannelDrawerEmbedContext);
}
